import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import moment from "moment";
import countryList from "react-select-country-list";
import placeholder from "../../assets/images/userprofile.png";
import { blobToFile } from "../../utils/helpers";
import ImageCropper from "../../Component/ImageCropper";
import SkeletonLoader from "../UpdateProfile/skeltonLoader";
import queryString from "query-string";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";

import {
  fetchUniversityPartners,
  fetchIndustries,
  fetchProgramStudies,
  fetchRegisterSettings,
  fetchAreas,
  fetchObjectives,
  fetchParticularPrograms,
  fetchLanguages,
  fetchExperience,
  fetchUserData,
  registerUser,
  fetchCoursesCompleted,
  fetchBoardExperienceMentor,
  fetchBoardEntityTypeExperience,
  fetchAccreditedDirector,
  fetchBoardExperienceLevel,
  fetchBoardExperience,
} from "../Authentication/Register/slice/registerSlice";

import {
  normalizeStudentSignup2Payload,
  buildStudentSignup2FormData
} from "./helpers/studentSignup2DataHelpers";
import { renderField, renderBoardRolesInline } from "./helpers/studentSignup2FieldRenderers";
import { fetchSettings } from "../../store/slices/settingsSlice";

const StudentSignup2 = (props) => {
  const dispatch = useDispatch();

  // Component-specific loading state to prevent flash
  const [componentReady, setComponentReady] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const {
    universityPartners: university_partners_list,
    industries: industry_list,
    programStudies: programStudyId,
    registerStepFields,
    areas,
    objectives: objective,
    particularPrograms: particularProgram,
    languages: languageOptions,
    experienceData: userExperience,
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
  } = useSelector((state) => state.register);

  const { setting } = useSelector((state) => state.settings);
  const programmes = useSelector((state) => state.programmes);
  const updateProfileData = useSelector((state) => state.updateProfileData);

  let d = new Date();
  d.setMonth(d.getMonth() + 3);
  const nextThreeMonthData = d.toLocaleDateString();
  const location = useLocation();
  const history = useNavigate();
  const { title, superUserParams } = props;
  const [dob, setDob] = useState(null);
  const { register, handleSubmit, setValue, reset, control, formState, formState: { errors }, watch, clearErrors, trigger } = useForm({
    defaultValues: superUserParams
  });

  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const siteName = setting?.name?.trim() || `Register Now as Mentor or Mentee`;

  useEffect(() => {
    const title = `${siteName} - Register Now as Mentor or Mentee`;
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        `Register now with ${setting?.name} as a mentor or mentee to join the domain-specific career mentoring between women leaders and experienced industry leaders.`
      );
  }, [siteName, title]);

  useEffect(() => {
    dispatch(fetchSettings());
  }, []);

  const queryStringParsed = queryString.parse(location.search);
  const [roleId, setRoleId] = useState("");
  const [showDateDiv, setShowDateDiv] = useState("none");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(nextThreeMonthData);
  const [emailVerifyString, setEmailVerifyString] = useState("");
  const [readOnly] = useState(false);
  const [industryData, setIndustryData] = useState("");
  const [redirectPath, setRedirectPath] = useState(null);

  const customStyles = {
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      top: "32px",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
  };

  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "Upload an Image",
  });
  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);
  const [getLoader, setGetLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const getUserId = localStorage.getItem("userId");
  const [userId, setUserId] = useState(localStorage.getItem("userId"));
  const options = countryList().getData();
  const [country] = useState(options);
  const [country1, setCountry1] = useState("");
  const [userData, setUserData] = useState({});

  const [mainArea, setMainArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);

  const [selectedObjective, setSelectedObjective] = useState([]);
  const [selectedResume, setSelectedResume] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [experienceData, setExperienceData] = useState([]);
  const [experience, setExperience] = useState([]);
  console.log("", experience)
  // Additional state for form functionality
  const [checkBox, setCheckBox] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [gender, setGender] = useState("");
  const [showPassword, setShowPassword] = useState(true);

  const countWords = (text) => {
    return text?.replaceAll('\r\n', '\n')?.length
  };

  const terminateProcess = registerStepFields?.[0]?.terminate_process;

  useEffect(() => {
    dispatch(fetchUniversityPartners());
    dispatch(fetchIndustries());
    dispatch(fetchParticularPrograms());
    dispatch(fetchAreas());
    dispatch(fetchProgramStudies());
  }, [setting]);

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    new Array(currentYear - 1990 + 1),
    (val, index) => 1990 + index
  );
  const checkFromDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setFromDate(formattedDate);
    return formattedDate;
  };

  const checkToDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setToDate(formattedDate);
    return formattedDate;
  };

  const [email, setEmail] = useState(queryStringParsed.email);

  const availabilityChecked = watch("availability");

  useEffect(() => {
    if (queryStringParsed.email) setValue("email", queryStringParsed.email);
    dispatch(fetchLanguages());
  }, [queryStringParsed.email]);

  const onSubmit = (data) => {
    let normalizedData = normalizeStudentSignup2Payload({
      data,
      roleId,
      dob,
      email_verify_string: emailVerifyString,
      selectedResume,
    });

    // Handle image file properly
    if (selectedFile && typeof selectedFile === "object" && selectedFile instanceof File) {
      normalizedData.image = selectedFile;
    }
    // Remove image property if no valid file is selected
    if ('image' in normalizedData && (!selectedFile || typeof selectedFile !== 'object' || !(selectedFile instanceof File))) {
      delete normalizedData.image;
    }

    if (
      selectedResume &&
      selectedResume instanceof File &&
      selectedResume.name &&
      selectedResume.size > 0 &&
      selectedResume.type === "application/pdf"
    ) {
      normalizedData.resume = selectedResume;
    } else {
      const { resume, ...rest } = normalizedData;
      normalizedData = rest;
    }

    const formData = buildStudentSignup2FormData({
      data: normalizedData,
      registerStepFields,
      selectedFile,
    });

    dispatch(
      registerUser({
        params: formData,
        roleId,
        userId,
        terminateProcess,
        step: "step_3",
        paramsLogin: null,
      })
    )
      .unwrap()
      .then((res) => {
        setGetLoader(false);

        if (!res) return;

        setPopupMessage(res?.message);
        setShowPopup(true);
        setRedirectPath(res.redirectTo);
      })
      .catch((error) => {
        setGetLoader(false);
        setPopupMessage(error?.message || "Registration failed");
        setShowPopup(true);
      });
  };

  const handlePopupOk = () => {
    setShowPopup(false);
    if (redirectPath) {
      history(redirectPath);
    }
  };

  const handleGender = (value) => {
    setGender(value);
  };

  const showDatePicker = (e) => {
    if (e.target.checked === true) {
      setShowDateDiv("block");
    } else {
      setShowDateDiv("none");
    }
  };

  const getExperienceData = () => {
    dispatch(fetchExperience());
  };

  const handleChange = (item, action) => {
    getExperienceData();
    setRoleId(item);

    // Fetch board-related data based on role
    if (item === "Mentor" || item === "Mentees") {
      dispatch(fetchCoursesCompleted());
      dispatch(fetchBoardExperience(item));
      dispatch(fetchBoardExperienceLevel(item));
      dispatch(fetchBoardEntityTypeExperience(item));
      dispatch(fetchAccreditedDirector(item));
      dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
    }
  };
  const handleProgrammesChange = (item, action) => {
    // Handle program change if needed
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const setText = (value) => {
    // Handle text change for textarea
  };

  const initializeUserState = (user) => {
    setUserData(user);

    setImg({
      src: user?.image || placeholder,
      alt: "Upload an Image",
    });

    const { image, resume, ...rest } = user || {};
    reset(rest);

    setValue("resume", user?.resume);
    setEmailVerifyString(user?.email_verify_string);
    setRoleId(user?.role_id);
    setUserId(user?.id);
    setSelectedFile(user?.image);
    setSelectedResume(user?.resume);
    setResumeText(user?.resume ? user.resume.split("resume/")[1] : "");

    setCheckBox2(!!user?.mf_certified_coach);
    setValue("mf_certified_coach", !!user?.mf_certified_coach);

    setDob(user?.dob);
  };

  const loadUserSelections = (user) => {
    const mainAreas = user?.domains ? user.domains.split(",") : [];
    const subAreas = user?.subareas ? user.subareas.split(",") : [];

    setMainArea(mainAreas);
    setSelectedArea(subAreas);

    setValue("mainArea", mainAreas);
    setValue("subarea", subAreas);
    setValue("domains", mainAreas);

    clearErrors("mainArea");
    clearErrors("domains");

    setSelectedObjective(user?.objective ? user.objective.split(",") : []);

    handleAvailability(user);
    handleGenderCountry(user);
    handleExperienceLevels(user);
    handleBooleanFields(user);
    handleDOB(user);
  };

  const handleAvailability = (user) => {
    if (user?.user_availability === 2) {
      setShowDateDiv("block");

      setValue("availability", true);
      setValue("from_date", checkFromDate(user?.user_availability_check?.start_time));
      setValue("to_date", checkToDate(user?.user_availability_check?.end_time));

    } else {
      setShowDateDiv("none");

      setValue("availability", false);
      setValue("from_date", null);
      setValue("to_date", null);
    }
  };

  const handleGenderCountry = (user) => {
    if (user?.gender) setGender(user.gender);
    if (user?.country) setCountry1(user.country);

    if (localStorage.getItem("student_img")) {
      setSelectedFile(
        blobToFile(localStorage.getItem("student_img"), getUserId + ".png")
      );
    }
  };

  const handleExperienceLevels = (user) => {
    if (!user?.experience_levels) return;

    setExperienceData(user.experience_levels);

    const selectedIds = user.experience_levels.map((item) => item.id);

    setExperience(selectedIds);
    setValue("experience_levels", selectedIds, { shouldDirty: true });
  };

  const handleBooleanFields = (user) => {
    if (user?.mn_open_to_talk !== undefined) {
      setValue("mn_open_to_talk", !!Number(user.mn_open_to_talk));
      clearErrors("mn_open_to_talk");
    }

    if (user?.mn_loking_for_coach !== undefined) {
      setValue("mn_loking_for_coach", !!Number(user.mn_loking_for_coach));
      clearErrors("mn_loking_for_coach");
    }
  };

  const handleDOB = (user) => {
    if (!user?.dob) return;

    setValue("dob", user.dob);
    clearErrors("dob");
  };

  const loadBoardData = (user) => {
    setMultiSelectField(user, "board_entity_type");
    setMultiSelectField(user, "board_entity_type_2");
    setMultiSelectField(user, "course_completed");
    setMultiSelectField(user, "accredited_director");
    setMultiSelectField(user, "indicate_board_experience_level");

    if (user?.past_board_roles) {
      const roles = user.past_board_roles.split(",").map((r) => r.trim());
      setValue("past_board_roles", roles);
      clearErrors("past_board_roles");
    }

    loadBoardRolesRepeater(user);

    setSingleSelectBoardFields(user);
  };

  const setMultiSelectField = (user, field) => {
    if (!user?.[field]) return;

    const values = user[field]
      .split(",")
      .map((id) => Number.parseInt(id.trim()));

    setValue(field, values);
    clearErrors(field);
  };

  const loadBoardRolesRepeater = (user) => {
    const data = user?.board_roles_data;
    if (!data) return;

    try {
      const roles = typeof data === "string" ? JSON.parse(data) : data;

      const formattedRoles = roles.map((role) => ({
        rep_company_name: role.rep_company_name || "",
        rep_board_title: role.rep_board_title || "",
        rep_start_date: role.rep_start_date || "",
        rep_end_date: role.rep_end_date || "",
        is_currently_working: !!role.is_currently_working,
      }));

      setValue("board_roles", formattedRoles);
      clearErrors("board_roles");

    } catch (err) {
      console.error("Error parsing board_roles:", err);
      setValue("board_roles", []);
    }
  };

  const setSingleSelectBoardFields = (user) => {
    const fields = ["years_of_board_experience"];

    for (const field of fields) {
      if (user?.[field] !== undefined) {
        setValue(field, user[field]);
        clearErrors(field);
      }
    }
  };

  const fetchBoardDependencies = (roleId) => {
    dispatch(fetchCoursesCompleted());
    dispatch(fetchBoardExperience(roleId));
    dispatch(fetchBoardExperienceLevel(roleId));
    dispatch(fetchBoardEntityTypeExperience(roleId));
    dispatch(fetchAccreditedDirector(roleId));
    dispatch(fetchBoardExperienceMentor("Mentee"));
  };

  useEffect(() => {
    const loadUserData = async () => {
      try {
        const res = await dispatch(fetchUserData(getUserId)).unwrap();
        const user = res?.data || {};

        initializeUserState(user);
        loadUserSelections(user);
        loadBoardData(user);

        dispatch(fetchObjectives(user?.role_id));
        dispatch(fetchRegisterSettings({ roleId: user?.role_id, stepKey: "step_3" }));
        getExperienceData();

        if (["Mentor", "Mentees"].includes(user?.role_id)) {
          fetchBoardDependencies(user?.role_id);
        }

        setTimeout(() => {
          setComponentReady(true);
          setInitialDataLoaded(true);
        }, 300);

      } catch (err) {
        console.error(err);
      }
    };

    loadUserData();
  }, [title, getUserId, setting, updateProfileData?.id, languageOptions]);

  const onChangePicture = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      setImg({ src: placeholder, alt: "Upload an Image" });
      setGetLoader(true);
      return;
    }

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setPopupMessage("Please select valid image format (jpg, jpeg, png)");
      setShowPopup(true);
      return;
    }

    // ✅ 30 MB check (STANDARDIZED)
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 30) {
      setPopupMessage("Please select image size less than 30 MB");
      setShowPopup(true);
      setImg({ src: placeholder, alt: "Upload an Image" });
      return;
    }

    clearErrors("image");

    setImg({
      src: placeholder,
      alt: file.name,
    });

    setCropImg(URL.createObjectURL(file));
    setCropImgModalShow(true);
    setGetLoader(false);
  };

  const onChangeResume = (e) => {
    if (e.target.files[0]) {
      const selectedResume = e.target.files[0];
      setSelectedResume(selectedResume);
      setResumeText(selectedResume.name);
      clearErrors('resume');
    }
  };

  const fileToImage = (childdata) => {
    const croppedFile = blobToFile(childdata, getUserId + ".png");
    setSelectedFile(croppedFile);
    setImg({
      src: URL.createObjectURL(childdata),
      alt: "",
    });

    setValue('image', croppedFile);
    clearErrors('image');
    trigger('image');
  };

  const clearAll = () => {
    setMainArea([]);
    setSelectedArea([]);

    setValue("mainArea", []);
    setValue("subarea", []);
    setValue("domains", []);

    clearErrors("mainArea");
    clearErrors("subarea");
    clearErrors("domains");

    trigger("mainArea");
    setSelectedObjective([]);
    setValue("objective", []);
    clearErrors("objective");
    trigger("objective");
  };

  useEffect(() => {
    if (selectedObjective.length > 0) {
      setValue("objective", selectedObjective);
      clearErrors("objective");
      trigger("objective");
    }
  }, [selectedObjective, setValue, clearErrors, trigger]);

  useEffect(() => {
    if (experienceData?.length > 0) {
      setExperience(experienceData.map((item) => item.id));
    }
  }, [experienceData]);
  // Create dependencies object for renderField
  const fieldDeps = {
    register,
    control,
    errors,
    watch,
    setValue,
    clearErrors,
    trigger,
    email,
    setEmail,
    readOnly,
    showPassword,
    togglePasswordVisibility,
    handleChange,
    roleId,
    email_verify_string: emailVerifyString,
    programmes,
    programStudyId,
    handleProgrammesChange,
    university_partners_list,
    years,
    userExperience,
    setExperience,
    country,
    country1,
    setCountry1,
    userData,
    languageOptions,
    customStyles,
    setIndustryData,
    industryData,
    industry_list,
    particularProgram,
    handleGender,
    gender,
    checkBox,
    setCheckBox,
    checkBox2,
    setCheckBox2,
    availabilityChecked,
    showDateDiv,
    checkFromDate,
    checkToDate,
    fromDate,
    toDate,
    showDatePicker,
    dob,
    setDob,
    src,
    alt,
    selectedFile,
    onChangePicture,
    resumeText,
    selectedResume,
    onChangeResume,
    mainArea,
    setMainArea,
    selectedArea,
    setSelectedArea,
    areas,
    selectedObjective,
    setSelectedObjective,
    objective,
    setText,
    countWords,
    // Board-related data
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
    formState,
    // Settings for board_roles_validation
    setting,
  };

  return (
    <div>
      <section className="loginouter studentsteps">
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
            <Row className="align-items-center justify-content-center">
              <Col md={12}>
                <div className="logininnerouter">
                  <div className="w-100">
                    <div className="loginlogo text-center mb-5 pb-4">
                      <Link to="/">
                        {setting?.logo_path && (
                          <img
                            src={setting?.logo_path}
                            alt="logo"
                            // style={{ maxWidth: "200px", maxHeight: "59px" }}
                          />
                        )}
                      </Link>
                    </div>

                    {/* SkeletonLoader */}
                    {(!componentReady || !initialDataLoaded) && <SkeletonLoader />}

                    {/* Main Content */}
                    <div style={{ display: (componentReady && initialDataLoaded) ? 'block' : 'none' }}>
                      {registerStepFields?.map((resp, index) => {
                        return (
                          <div className="loginform" key={resp?.id || index}>
                            <h1>{resp?.step_label}</h1>
                            <div className="steps_signup">
                              <div>
                                <span className="stepcount active">1</span>
                                <span className="stepcount active">2</span>
                                <span className="stepcount">3</span>
                                <span className="stepcount">4</span>
                              </div>
                            </div>
                            <div
                              className="mt-3"
                              style={{
                                marginTop: "0em",
                                display: "block",
                              }}
                            >
                              <div className="businessboxouter">
                                {(() => {
                                  let renderedBoardRoleFields = new Set();

                                  return (
                                    <>
                                      {resp?.reg_feilds?.map((field, idx) => {
                                        const boardRoleFieldKeys = ['rep_company_name', 'rep_board_title', 'rep_start_date', 'rep_end_date'];
                                        const isBoardRoleField = boardRoleFieldKeys.includes(field.reg_key);

                                        if (renderedBoardRoleFields.has(field.reg_key)) {
                                          return null;
                                        }

                                        if (isBoardRoleField && field.reg_key === 'rep_company_name') {
                                          renderedBoardRoleFields.add('rep_company_name');
                                          renderedBoardRoleFields.add('rep_board_title');
                                          renderedBoardRoleFields.add('rep_start_date');
                                          renderedBoardRoleFields.add('rep_end_date');

                                          return (
                                            <React.Fragment key="board_roles_group">
                                              {renderBoardRolesInline(resp?.reg_feilds, { ...fieldDeps, setting })}
                                            </React.Fragment>
                                          );
                                        }

                                        if (isBoardRoleField) {
                                          return null;
                                        }

                                        return (
                                          <React.Fragment key={field.reg_key}>
                                            {renderField(field, fieldDeps)}
                                          </React.Fragment>
                                        );
                                      })}
                                    </>
                                  );
                                })()}
                              </div>
                            </div>
                            <div className="form-group mt-3 text-center">
                              <Button
                                className="btn loginsubmit outline me-2"
                                onClick={clearAll}
                                title={"Clear All"}
                                disabled={getLoader}
                              >
                                Clear All
                              </Button>
                              <Button
                                className="btn loginsubmit nextbtn outline me-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  history("/registration-step-1");
                                }}
                                disabled={getLoader}
                              >
                                Previous
                              </Button>
                              <button
                                type="submit"
                                className="btn loginsubmit nextbtn ml-2 btn-red"
                                disabled={getLoader}
                              >
                                {terminateProcess === "Yes"
                                  ? "Submit"
                                  : "Save & Next"}
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      </section>

      {cropImgModalShow && (
        <ImageCropper
          show={cropImgModalShow}
          cropImg={cropImg}
          fileToImage={fileToImage}
          onHide={() => setCropImgModalShow(false)}
          centered
          size="xl"
          className="cropper-modal"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={true}
        staticBackdrop={true}
        onConfirm={handlePopupOk}
      />

    </div>
  );
};

StudentSignup2.propTypes = {
  title: PropTypes.string,
  superUserParams: PropTypes.object,
};

StudentSignup2.defaultProps = {
  title: "",
  superUserParams: {},
};

export default StudentSignup2;